import SingleProductBindingPanel from './singleProductBindingPanel.container'

export default SingleProductBindingPanel